export const useIpDataStore = defineStore('ipData', {
  state: () => ({
    ipData: null,
  }),
  actions: {
    async fetch(ipAddress, token) {
      ipAddress = ['127.0.0.1', 'localhost'].includes(ipAddress)
        ? ''
        : ipAddress;
      const ipData = await $fetch(
        `https://pro.ip-api.com/json/${ipAddress || ''}?key=${token}`
      );
      this.setData(ipData);
    },
    setData(ipData) {
      this.ipData = ipData;
    },
  },
  getters: {
    countryCode: (state) => state.ipData?.country,
  },
});
